export default function validateHexColorString(hexColor: string): boolean {
    const validation = new RegExp('^#[0-9a-f]{6}$', 'gi');
    return !!validation.exec(hexColor);
}
